import React from 'react';

const DisplayValue = ({ value }: { value: string | number }) => <>{value}</>;

export default DisplayValue;
